import * as React from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import CustomFormControl, {
  CustomFormControlProps,
} from '../custom-form-control';
import { FormContext } from '../form';
import Tag, { TagProps } from '../tag';

export interface TagInputProps
  extends Omit<TagProps, 'tags' | 'error'>,
    Omit<CustomFormControlProps, 'children'> {
  type: 'tag';
  fieldType?: 'control' | 'uncontrol' | any;
}

export default function TagInput(props: TagInputProps) {
  const { control } = useFormContext<any>();
  const watchValue = useWatch({ control, name: props.name });
  const { field, fieldState } = useController({ name: props.name });
  const context = React.useContext(FormContext);
  const { placeholder, inputType, fieldType = 'control', ...rest } = props;

  const shouldShowError = !!fieldState.error?.message;
  return (
    <CustomFormControl
      {...rest}
      error={fieldState.error?.message}
      disabled={!context.editable || rest.disabled || rest.readOnly}
    >
      <Tag
        placeholder={placeholder}
        error={shouldShowError}
        tags={fieldType === 'control' ? field.value : watchValue}
        name={props.name}
        disabled={!context.editable || rest.disabled || rest.readOnly}
        onChange={(value) => field.onChange(value)}
        inputType={inputType}
      />
    </CustomFormControl>
  );
}
